import React, { useEffect, useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import { useSelector, useDispatch } from "react-redux"
import clsx from 'clsx';
import { sharedTypographyStyles } from './sharedStyles';
import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
  colors,
  ListItem,
  ListItemText,
  ListItemIcon,
  Paper,
  CardHeader
} from '@material-ui/core';
import Link from '@material-ui/core/Link';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import Filter1Icon from '@material-ui/icons/Filter1';
import Filter2Icon from '@material-ui/icons/Filter2';
import Filter3Icon from '@material-ui/icons/Filter3';
import Filter4Icon from '@material-ui/icons/Filter4';
import CheckIcon from '@material-ui/icons/Check';
import StarsIcon from '@material-ui/icons/Stars';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import Container from '@material-ui/core/Container';
import { mainListItems, SecondaryListItems } from '../listItems';
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png"
import * as AuthActions from "../../../store/actions/auth";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  ...sharedTypographyStyles,
  root: {
    height: '100%',
    borderRadius: 14,
    background: '#f7faff',
    boxShadow: '0 6px 32px rgba(0,45,85,0.18)',
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55"
  },
  avatar: {
    backgroundColor: '#6a8caf',
    height: 'clamp(20px, 2.2vw, 36px)',
    width: 'clamp(20px, 2.2vw, 36px)',
    marginRight: 0,
    marginLeft: 0,
    marginTop: 0,
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(6),
    [theme.breakpoints.up('xs','sm', 'md')]: {
      width: theme.spacing(6),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
    paddingLeft: theme.spacing(0),
  },
  paper: {
    padding: 16,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)',
    borderRadius: 16,
  },
  drawerArrow: {
    marginLeft: 8,
    fontSize: 'clamp(14px, 1.15vw, 18px)',
    transition: 'transform 0.2s ease',
    display: 'inline-block',
  },
  fixedHeight: {
    height: 'auto',
  },
}));


export const Recovery_phases = ({ className, phaseIndex: propPhaseIndex, treatmentId, ...rest }) => {
  const classes = useStyles();
  const token = useSelector(state => state.auth.token);
  const [loading, setLoading] = useState(true);
  const [phaseIndex, setPhaseIndex] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [phaseData, setPhaseData] = useState({ progress: "?", title: "?" });
  const [diagnosis, setDiagnosis] = useState({ title: "", explainer: "", identifier: "" });
  const [openPhaseIndex, setOpenPhaseIndex] = useState(null);

  useEffect(() => {
    if (propPhaseIndex !== undefined && propPhaseIndex !== null) {
      setPhaseIndex(propPhaseIndex);
      setOpenPhaseIndex(propPhaseIndex);
    }
  }, [propPhaseIndex]);

  useEffect(() => {
    if (token && treatmentId) {
      fetchDiagnosisDataByTreatment();
    } else if (token) {
      fetchDiagnosisData();
    }
    // eslint-disable-next-line
  }, [token, treatmentId]);

  useEffect(() => {
    if (phaseIndex !== null) {
      setOpenPhaseIndex(phaseIndex);
    }
  }, [phaseIndex]);

  const fetchDiagnosisDataByTreatment = async () => {
    setIsFetching(true);
    try {
      const response = await fetch(`https://api.virtus-one.com/treatment/phase/progress/treatment/${treatmentId}/`, {
        headers: { "Authorization": `Token ${token}` },
        method: "GET",
      });
      if (response.ok) {
        const data = await response.json();
        setDiagnosis({
          title: data.diagnosis_title || "",
          explainer: data.diagnosis_explainer || "",
          identifier: data.diagnosis_identifier || ""
        });
        setPhaseData({ 
          progress: data.progress, 
          title: data.name, 
          phaseIndex: data.phaseIndex 
        });
        setPhaseIndex(data.phaseIndex);
      } else {
        alert("ERROR fetching phase data");
      }
    } catch (err) {
      console.error('Failed to fetch phase by treatment', err);
    }
    setIsFetching(false);
  };

  const fetchDiagnosisData = async () => {
    setIsFetching(true);
    const response = await fetch("https://api.virtus-one.com/treatment/diagnosis/", {
      headers: { "Authorization": `Token ${token}` },
      method: "GET",
    });
    if (response.ok) {
      const data = await response.json();
      setDiagnosis({ ...data[0].diagnosis });
      fetchPhaseData(data[0].diagnosis);
    } else {
      alert("ERROR");
    }
    setIsFetching(false);
  };

  const fetchPhaseData = async (__diagnosis) => {
    const response = await fetch("https://api.virtus-one.com/treatment/phase/progress/" + __diagnosis.identifier, {
      headers: { "Authorization": `Token ${token}` },
      method: "GET",
    });
    if (response.ok) {
      const data = await response.json();
      setPhaseData({ progress: data.progress, title: data.name, phaseIndex: data.phaseIndex });
      setPhaseIndex(data.phaseIndex);
    } else {
      alert("ERROR");
    }
  };

  const phases = [
    {
      title: "Phase 1: 'Pain control'",
      description:
        "Get control over your pain so it doesnt get worse by protecting the painful area for a period of time by modifying or avoiding pain provocating activities, movements and habits. Try to build a good understanding of which movements and activities that betters or worsens your pain. Use specific exercises to reduce your pain regularily. Average duration: 1-2 weeks.",
      icon: <Filter1Icon />,
    },
    {
      title: "Phase 2: 'Retrain function'",
      description:
        "Start retraining your strength, stability, neuromuscular control and endurance with specific strengthening and conditioning exercises. Regain pain-free movement of your painful area but also improve the mobility of other relevant joints in relation to your specific pain in order to optimize the load distribution throughout your body. Average duration: 2-4 weeks.",
      icon: <Filter2Icon />,
    },
    {
      title: "Phase 3: 'Challenge it'",
      description:
        "Gradually let your body adapt to become stronger and more functional by increasing the difficulty level, intensity and amount of your exercises following a specific rehabilitation protocol.",
      icon: <Filter3Icon />,
    },
    {
      title: "Phase 4: 'Back to your best'",
      description:
        "If relevant for your condition this phase will be the beginning of more sportspecific exercises to return safely to sport-, fitness- or recreational activities again. If your situation does not involve a sport-, fitness- or recreational activity goal, you will skip those exercises and get guidance on how to best prevent your pain from returning and maintain your strength, endurance, joint mobility and -stability.",
      icon: <Filter4Icon />,
    },
  ];

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardHeader
        avatar={<Avatar className={classes.avatar}><TrendingUpIcon style={{ color: '#fff', fontSize: 'clamp(14px, 1.4vw, 22px)' }} /></Avatar>}
        title={<span className={classes.cardHeaderTitle}>Recovery phases</span>}
        style={{ background: '#f7faff', marginBottom: 0, borderBottom: "2px solid #fb741a", padding: 10, alignItems: 'center', marginTop: 0 }}
      />
      <CardContent style={{ width: "100%", background: '#f7faff' }}>
        <Grid container spacing={0} style={{ width: "100%", margin: 0, background: 'transparent' }}>
          <Grid container direction="row" >
            <Grid item xs={12}>
              <Typography
                className={classes.sectionText}
                color="textSecondary"
                gutterBottom
                variant="h7"
              >
                Overall most patients will have to go through 4 recovery phases. Click the phase titles to read about the different recovery phases below.
              </Typography>
            </Grid>
            <Grid xs={12} container direction="column" style={{ width: "100%", background: 'transparent' }}>
              <Timeline align="alternate">
                {phases.map((phase, idx) => (
                  <TimelineItem
                    key={idx}
                    style={{
                      color: "#002D55",
                      paddingBottom: 10,
                      background: openPhaseIndex === idx ? 'transparent' : 'none',
                      border: openPhaseIndex === idx ? '0px solid #b3d3ea' : 'none',
                      borderRadius: 16,
                      paddingTop: 0,
                      cursor: 'pointer',
                    }}
                  >
                    <TimelineSeparator>
                      <TimelineDot style={{ color: "#002D55", background: '#FFF',}}>
                        {React.cloneElement(phase.icon, { style: { color: openPhaseIndex === idx ? "#fb741a" : "#002D55", backgroundColor: "transparent" } })}
                      </TimelineDot>
                      <TimelineConnector style={{ color: "#002D55", backgroundColor: "#002D55" }} />
                    </TimelineSeparator>
                    <TimelineContent onClick={() => setOpenPhaseIndex(idx)}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', cursor: 'pointer', boxShadow: '0 2px 12px rgba(106,140,175,0.17)', borderRadius: openPhaseIndex === idx ? '14px 14px 0 0' : 14, padding: 4, marginBottom: 0, paddingLeft: 16, paddingRight: 12, backgroundColor: '#FFFFFF', }}>
                        <Typography variant="h1" className={classes.sectionHeader} style={{ textAlign: "left", flex: 1 }}>
                          {phase.title}
                        </Typography>
                        <span
                          className={classes.drawerArrow}
                          style={{ color: openPhaseIndex === idx ? '#FF7F27' : '#002D55', transform: openPhaseIndex === idx ? 'rotate(0deg)' : 'rotate(-90deg)' }}
                        >
                          ▼
                        </span>
                      </div>
                      <Collapse in={openPhaseIndex === idx} timeout="auto" unmountOnExit>
                        <Paper elevation={3} className={classes.paper} style={{ borderRadius: '0 0 16px 16px' }}>
                          <Typography className={classes.sectionText} style={{ textAlign: "left" }}>
                            {phase.description}
                          </Typography>
                        </Paper>
                      </Collapse>
                    </TimelineContent>
                  </TimelineItem>
                ))}
                <Grid container justify="center" style={{marginRight: "0.5%"}}>
                  <TimelineDot style={{color: "#002D55", backgroundColor: "#FFFFFF"}}>
                    <CheckIcon style={{color: phaseIndex === 0 ? "#fb741a" : "#002D55", backgroundColor: "transparent"}} />
                  </TimelineDot>
                </Grid>
              </Timeline>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Recovery_phases.propTypes = {
  className: PropTypes.string,
  phaseIndex: PropTypes.number,
  treatmentId: PropTypes.string,
};

export default Recovery_phases;